import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { FilesService, ToastService } from 'src/app/services';
import { SectionFileData } from 'src/app/models';
import { formatSizeUnits } from 'src/app/resources/Utils';
import { FileConfig, FileOptions, ConfigurationEvent } from 'src/app/models/tool.model';


@Component({
    selector: 'app-input-file-info',
    templateUrl: './input-file-info.component.html',
    styleUrls: ['./input-file-info.component.scss'],
    standalone: false
})
export class InputFileInfoComponent implements OnInit, AfterViewInit {

  constructor(
    private filesService: FilesService,
    private toastService: ToastService
  ) { }

  @Input() data: SectionFileData;
  @Input() selector: string;
  @Output() delete = new EventEmitter<SectionFileData>();
  @Output() sendSelectedConfigToParent = new EventEmitter<ConfigurationEvent>();

  parent: HTMLElement;

  @ViewChild('edit') edit: ElementRef;

  ngOnInit() { }


  /**
   * Manages when a box containing uploaded files must collapse or open, especially for NLL
   */

  ngAfterViewInit() {
    if (!this.edit) { return; }
    const target = this.edit.nativeElement;
    const container = target.parentElement;
    this.parent = target.offsetParent;

    const edit = this.parent.querySelectorAll('.edit');
    const btn = this.parent.querySelectorAll('.btn-edit');
    const element = this.parent.querySelectorAll('.contianer-collapse ');

    this.getElementAtStart('hidden', edit);
    this.getElementAtStart('collapsed', btn);
    this.getElementAtStart('show', element);

    target.addEventListener('click', () => {
      const button = this.parent.querySelectorAll('.edit.hidden');
      button.forEach(e => {
        e.classList.remove('hidden');
      });
      container.classList.add('hidden');
    });
  }

  getElementAtStart(type: string, element: NodeListOf<Element>) {
    element.forEach((e) => {
      const id = e.id.split('-');
      if (id[id.length - 1] === '0') {
        e.classList.add(type);
      } else {
        e.classList.remove(type);
      }
    });
  }

  /**
   * Returns the value selected from the select of the file configurations
   * @param $event Selected option
   * @param config Configuration
   * @param fileId File id
   */

  getSelectedItem($event: FileOptions, config: FileConfig, fileId: string) {
    config.values.map(val => (val.value === $event.value) ? val.isChecked = !val.isChecked : val.isChecked = false);
    this.sendSelectedConfigToParent.emit({fileId, configName: config.name, configValue: $event.value});
  }

  /**
   * Delete single file and sends info to the parent component
   * @param data Section containing the file
   */
  async deleteFile(data: SectionFileData) {
    if (data.isInvalid) {
      this.delete.emit(data);
    } else {
      try {
        const res = await this.filesService.deleteSingleFile(data.info.id);
        if (res.status) {
          this.delete.emit(data);
        }
      } catch (error) {
        this.toastService.showError(error.error);
        console.error('error =>', error);
      }
    }
  }

  /**
   * Format the file size
   * @param data File size
   */
  handleSize(data: number) {
    return formatSizeUnits(data);
  }
}
